import { render, staticRenderFns } from "./TheNotifications.vue?vue&type=template&id=74f1b3ba&scoped=true"
import script from "./TheNotifications.vue?vue&type=script&lang=js"
export * from "./TheNotifications.vue?vue&type=script&lang=js"
import style0 from "./TheNotifications.vue?vue&type=style&index=0&id=74f1b3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f1b3ba",
  null
  
)

export default component.exports